import React from "react";

export const STATUS_FILTERS = [
  { value: null, title: "All", countKey: "all" },
  { value: "Verified", title: "Reconciled", countKey: "verified" },
  { value: "Review", title: "Review", countKey: "review" },
  { value: "Pending", title: "No match", countKey: "pending" },
];

export default function StatusFilter({ counts = {}, activeStatus, onSelect }) {
  return (
    <div className="w-full flex flex-row flex-wrap items-center gap-2 pt-2">
      {STATUS_FILTERS.map(({ value, title, countKey }) => {
        const count = Number(counts?.[countKey] || 0);
        const isActive = activeStatus === value;
        const isReview = value === "Review";
        const highlightReview = isReview && count > 0 && !isActive;

        return (
          <button
            key={countKey}
            type="button"
            onClick={() => onSelect(value)}
            className={`rounded-md px-3 py-1 border text-xs flex flex-row items-center gap-2 transition-all ${
              isActive
                ? isReview
                  ? "bg-orange-500 text-white border-orange-500"
                  : "bg-primary text-white border-primary"
                : highlightReview
                ? "bg-orange-50 text-orange-700 border-orange-400 font-bold"
                : "bg-white text-gray-600 hover:border-primary"
            }`}
          >
            {title}
            <span
              className={`rounded-full px-1 ${
                isActive
                  ? "bg-white/20"
                  : highlightReview
                  ? "bg-orange-200"
                  : "bg-gray-100"
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
